import { z } from 'zod';
import { Id, IsoDate } from './common';
/** Mission HQ inbox items: same unseen → seen → read model as tenant notifications. */
export const HqNotificationKinds = [
    'inquiry.created',
    'offer.claimed',
    'domain.live',
    'subscription.expiring',
    'job.failed',
    'tenant.deletion_scheduled',
];
export const HqNotificationSchema = z.object({
    id: Id,
    kind: z.enum(HqNotificationKinds),
    title: z.string(),
    body: z.string().nullable(),
    tenant: z.object({ id: Id, name: z.string() }).nullable(),
    href: z.string().nullable(),
    seenAt: IsoDate.nullable(),
    readAt: IsoDate.nullable(),
    createdAt: IsoDate,
});
//# sourceMappingURL=hq-notifications.js.map